import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { GridConstants } from '../../constants/Grid';
import { PandoraTypes } from '../../constants/SourceTypes';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, getDefaultArtByType, getDominantColor } from '../../lib/ArtUtils';
import { getAnnotationsById } from '../../lib/EntityUtils';
import { getSourceCardMenuItems } from '../../lib/SourceCardUtils';
import PodcastEpisodeMetadata from '../PodcastEpisodeMetadata/PodcastEpisodeMetadata';

import CatalogGridItem from './CatalogGridItem';

/**
 * PodcastEpisodeGridItem is for rendering T3 podcast episode grid items.
 *
 * See CatalogGridItem and lib/GridItem for additional available props.
 */
class PodcastEpisodeGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
    mainText: PropTypes.string,
    mainTextUrl: PropTypes.string,
    secondText: PropTypes.string,
    episodeDuration: PropTypes.number,
    elapsedTime: PropTypes.number,
    releaseDate: PropTypes.string,
    isFinished: PropTypes.bool,
    isPlayingCurrently: PropTypes.bool,
    isPaused: PropTypes.bool,
    showSourceName: PropTypes.bool,
  };

  render() {
    const {
      episodeDuration,
      elapsedTime,
      releaseDate,
      isFinished,
      showSourceName,
      ...gridItemProps
    } = this.props;

    return (
      <CatalogGridItem
        thirdText={
          <PodcastEpisodeMetadata
            episodeDuration={episodeDuration}
            elapsedTime={elapsedTime}
            releaseDate={releaseDate}
            isFinished={isFinished}
            showSourceName={showSourceName}
          />
        }
        {...gridItemProps}
      />
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const props = {};
  const { id, isMixedWithOtherSources } = ownProps;
  const details = getAnnotationsById(state, id);
  props.blankItem = !details;
  props.defaultPlaceholderArt = !details
    ? getDefaultArtByType(PandoraTypes.EPISODE, GridConstants.GRID_ITEM_IMAGE_SIZE)
    : null;

  if (details && id) {
    const progressDetails = getInDomain('playback.utils.getPodcastEpisodeProgressById', null)(
      state,
      id,
    );
    const backstageUrl = details.get('shareableUrlPath');
    const elapsedTime = progressDetails ? progressDetails.get('elapsedTime') : 0;
    props.mainText = details.get('name');
    props.mainTextUrl = backstageUrl;
    props.itemOnclickUrl = backstageUrl;
    props.secondText = details.get('programName');
    props.releaseDate = details.get('releaseDate');
    props.imgUrl = getArt(details, GridConstants.GRID_ITEM_IMAGE_SIZE, state, PandoraTypes.EPISODE);
    props.dominantColor = getDominantColor(details);
    props.isPlayingCurrently = getInDomain('playback.utils.isTrackPlayingCurrently', false)(
      state,
      id,
    );
    props.isPaused =
      !getInDomain('playback.utils.isAudioPlaying')(state) && props.isPlayingCurrently;
    props.elapsedTime = props.isPlayingCurrently && !props.isPaused ? 0 : elapsedTime;
    props.isFinished = progressDetails && progressDetails.get('isFinished');
    props.episodeDuration = details.get('duration');
    props.isExplicit = !props.elapsedTime && getInDomain('catalog.utils.isExplicit')(details);
    props.isClean = !props.elapsedTime && getInDomain('catalog.utils.isClean')(details);
    props.showSourceName = isMixedWithOtherSources;
    props.sourceCardMenuItems = getSourceCardMenuItems({
      state,
      pandoraId: id,
      pandoraType: PandoraTypes.EPISODE,
    });
  }
  return props;
}

export default connect(mapStateToProps)(PodcastEpisodeGridItem);
